<template>
  <v-flex
    xs12
    sm12
    align-self-center
  >

    <v-container
      class="login-text"
      grid-list-md
      text-xs-center>
      <v-layout
        align-center
        align-content-center
        justify-center
        row
        gradient="to top right, rgba(100,115,201,.40), rgba(25,32,72,.7)"
        style="webkit-linear-gradient(to top right, rgba(100,115,201,.40), rgba(25,32,72,.7));"
      >

        <v-flex
          md12
          xs12
          sm12>
          <v-icon
            v-for="(l, index) of links_"
            :key="index"
            :title="(l.textHome) ? l.textHome[idioma] : l.text[idioma]"
            left
            dark>{{ l.icon }}</v-icon>
          <div id="descricao">
            <h3
              style="text-align: justify; font-size: 25px!important; font-weigth:300!important; color: #fff!important"
              v-html="strings[idioma].descricao_login"/>
          </div>
          <PostsWP v-if="$store.state.app.exibeBlog"/>

        </v-flex>
      </v-layout>
    </v-container>
  </v-flex>
</template>
<style scoped>
.login-text{
  padding-top: 100px;

  overflow: auto;
}
.login-text div{
  -webkit-filter: blur(0px);
  -moz-filter: blur(0px);
  -o-filter: blur(0px);
  -ms-filter: blur(13px);
  filter: blur(0px);

  -webkit-backdrop-filter: blur(2px); /* Safari 9+ */
  backdrop-filter: blur(2px); /* Chrome and Opera */

  overflow: auto;
}
</style>
<script>
import {
  mapState
} from 'vuex'
import PostsWP from '../PostsWP'
export default {
  components: {
    PostsWP
  },
  data () {
    return {
      background: 'img/drawer-bg.jpg',
      logo: 'img/br-corte-logobranca.png'
      // img/br-corte-logobranca.png
    }
  },
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'links_']),
    heightOverflow () {
      return 'margin: 0; padding: 20px; max-height: ' + String(this.$vuetify.breakpoint.height) + 'px; overflow: auto;'
    }
  }
}
</script>
